module.exports = __webpack_public_path__ + "img/card5.135841b2.png";